import React from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentProvider } from '../../store/itinerary/itinerary.selectors'
import { selectPreferredFuel, selectPreferredVehicle } from '../../store/itineraryOptions/itineraryOptions.selectors'
import T from '../i18n/T'
import s from './ExpenseReport.less'

const ExpenseReportVehicleSection = () => {
  const modeId = useSelector(selectCurrentProvider)
  const vehicle = useSelector(selectPreferredVehicle(modeId))
  const fuel = useSelector(selectPreferredFuel(modeId))

  return (
    <div className={s.block}>
      <div>
        <T id={'itinerary.expense.vehicle-type'} /> : <strong>{vehicle?.label}</strong>
      </div>
      <div>
        <T id={'itinerary.expense.vehicle-fuel'} /> :&nbsp;
        <strong>
          {fuel && (
            <>
              {fuel.label} ({fuel.price} {fuel.price_unit})
            </>
          )}
        </strong>
      </div>
      <div>
        <T id={'itinerary.expense.vehicle-edit'} />
      </div>
    </div>
  )
}

export default ExpenseReportVehicleSection
